$(function() {
    $(document).on('click', '.btn-show-popup-form', function(e){
        e.preventDefault();
        window.showPopupForm = true;

        const $closest = $(this).closest('div');
        
        if ($closest.find('.popup-form-value').length) {
            $('.popup-form-value').attr('data-additions-value', 'true');
            $('.popup-form-unit').attr('data-additions-unit', 'true');
        } else {
            $('.popup-form-value').removeAttr('data-additions-value');
            $('.popup-form-unit').removeAttr('data-additions-unit');
        }
    });
});